import { ReactNode, useEffect } from 'react';
import '../i18n/config';

interface I18nProviderProps {
  children: ReactNode;
}

export function I18nProvider({ children }: I18nProviderProps): JSX.Element {
  useEffect(() => {
    // i18n is initialized via config import
  }, []);

  return <>{children}</>;
}
